import { render, staticRenderFns } from "./HerbicideDikeStatistics.vue?vue&type=template&id=3b46df36&"
import script from "./HerbicideDikeStatistics.vue?vue&type=script&lang=js&"
export * from "./HerbicideDikeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports